module.exports = __webpack_public_path__ + "img/prt.170452f4.jpg";